import { DownOutlined } from "@ant-design/icons";
import { Dropdown, type MenuProps, Space } from "antd";
import type { FC } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";

import { Languages, setLanguage } from "src/translations";
import { changeLang, type LanguageState } from "../../core/setup/redux/state/language/languageState";
import { CustomIcon } from "../Icon/custom";
import { CustomIconCodes } from "../Icon/custom/CustomIcon";

/**
 * Properties of the Language component
 * */
export type LanguageProps = Readonly<{}>;

/**
 * Default component for language switching.
 * */
export const Language: FC<LanguageProps> = () => {
    const { t } = useTranslation();

    const currentLang = useSelector((state: { language: LanguageState }) => state.language.currentLang);
    const dispatch = useDispatch();

    const setCurrentDisplayedFlag = (key: Languages) => {
        switch (key) {
            case Languages.fr:
                return CustomIconCodes.FlagFrance;
            case Languages.en:
                return CustomIconCodes.FlagUSA;
            case Languages.de:
                return CustomIconCodes.FlagGermany;
            default:
                return CustomIconCodes.FlagUSA;
        }
    };

    const switchLanguage: MenuProps["onClick"] = ({ key }) => {
        dispatch(changeLang(key as Languages));
        setLanguage(key as Languages);
    };

    const menuItems: MenuProps["items"] = [
        {
            key: Languages.en,
            label: (
                <>
                    <CustomIcon iconSource={CustomIconCodes.FlagUSA} /> {t("english")}
                </>
            ),
        },
        {
            key: Languages.de,
            label: (
                <>
                    <CustomIcon iconSource={CustomIconCodes.FlagGermany} /> {t("german")}
                </>
            ),
        },
        {
            key: Languages.fr,
            label: (
                <>
                    <CustomIcon iconSource={CustomIconCodes.FlagFrance} /> {t("french")}
                </>
            ),
        },
    ];

    return (
        <Dropdown menu={{ items: menuItems, onClick: switchLanguage }} trigger={["click"]}>
            <Space>
                <CustomIcon iconSource={setCurrentDisplayedFlag(currentLang)} />
                <DownOutlined />
            </Space>
        </Dropdown>
    );
};
